export const UPDATE_VALUE = 'CLICK_UPDATE_VALUE';
export const UPDATE_HEADER = 'CLICK_UPDATE_HEADER';
export const UPDATE_CONTENT_TYPE = 'CLICK_UPDATE_CONTENT_TYPE';
export const UPDATE_SCORE_POINTS = 'UPDATE_SCORE_POINTS';
export const UPDATE_POINTS = 'UPDATE_VALUE_POINTS';